import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

// CRITICAL: Replace CDN React with bundled React to ensure single React instance
// The CDN React in HTML ensures it's available early for IIFE builds,
// but we replace it with the bundled React to avoid "Invalid hook call" errors
if (typeof window !== "undefined") {
  // Replace CDN React with bundled React (same version, prevents duplicate React errors)
  window.React = React;
  window.ReactDOM = ReactDOM;
}

ReactDOM.render(<App />, document.getElementById("root"));
